import { useEffect, useState } from "react";

// Справка по конструктору и дашборду адаптации. [Claude] 2026-11-02, Чат 3, №7

const SECTIONS = [
    {
        key: "overview",
        title: "Как это устроено",
        body: [
            ["Схема", "Вопрос → Анкета → Этап. Вопросы лежат в библиотеке. Из них собираются анкеты (набор вопросов для одного участника). Этап говорит, кому и когда отправить анкеты и кто их заполняет."],
            ["Стандартные этапы", "1 неделя, 1 месяц, 2 месяца и контроль 2 месяцев работают как раньше. Их анкеты скопированы в библиотеку как шаблоны «Стандарт: …» — их можно скопировать, изменить и подставить в любой этап."],
            ["Порядок работы", "1) Вопросы: проверьте или добавьте нужные. 2) Анкеты: соберите анкету для каждого участника. 3) Участники: при необходимости добавьте свою роль, например наставника. 4) Этапы: создайте этап, нажмите «Предпросмотр», затем сохраните."],
            ["Безопасность правок", "Уже отправленные и заполненные анкеты никогда не меняются. Правка вопроса, анкеты или этапа попадает только в будущие незаполненные этапы."],
        ],
    },
    {
        key: "stages",
        title: "Этапы",
        body: [
            ["Когда", "«Через N от выхода» — дни, недели или месяцы от даты выхода сотрудника. «С конкретной даты» — для группы людей в один день. «Заменить анкеты стандартного этапа» — оставить сроки 1 недели / 1 и 2 месяцев, но поменять вопросы или участников."],
            ["Повтор", "Еженедельно, ежемесячно или каждые N дней; ограничение — число повторов или дата окончания. Выходные по умолчанию переносятся на понедельник."],
            ["Кому", "«Все в адаптации» или выбор: отделы, должности (по вхождению слова: «логист» найдёт «Старший логист»), конкретные сотрудники. Отделы и должности вместе — пересечение (например, логисты только из Логистики). Отмеченные сотрудники добавляются всегда."],
            ["Новые сотрудники", "Флажок «автоматически для новых сотрудников» — этап появится у всех, кто придёт позже и подходит под условия. Проверка идёт 2 раза в час."],
            ["Прошедшие даты", "По умолчанию этапы с датой в прошлом не создаются (чтобы не засыпать людей старыми анкетами). Включите «создавать и с прошедшей датой», если это нужно."],
            ["Участники", "Для каждого участника — своя анкета. «Обязателен для завершения»: этап считается завершённым, когда ответили все обязательные. Необязательный участник может ответить позже."],
            ["Предпросмотр", "Показывает, у кого и на какие даты этап будет создан, обновлён или снят. Ничего не сохраняет."],
            ["Выключение", "Снимите «Активен» — будущие незаполненные этапы этого правила снимутся, заполненные останутся."],
        ],
    },
    {
        key: "forms",
        title: "Анкеты и условия",
        body: [
            ["Анкета", "Набор вопросов для одного участника. Порядок — стрелками ↑ ↓, «обяз.» — обязательный ответ. Одну анкету можно использовать в разных этапах."],
            ["Условие показа", "Вопрос появится, только если выполнено условие по вопросу выше. Пример: «Почему стало хуже?» — показать, если «Комфорт» снизился к прошлому этапу на ≥ 1 (4 → 3)."],
            ["Сравнения", "≤ < ≥ > = — с порогом (например, «≤ 2» — спросить, почему так низко). «Снизилась / выросла / изменилась к прошлому этапу на ≥ N» — по ответу этого же человека на прошлом этапе. «Один из / не из» — для вариантов. «Заполнен» — если ответ дан."],
            ["И / ИЛИ", "Несколько условий: «достаточно любого (ИЛИ)» или «нужны все (И)»."],
            ["Предпросмотр", "Справа анкета как её увидит участник. Отвечайте — условия срабатывают сразу. Поля «ответы на прошлом этапе» позволяют проверить условия «снизилась / выросла»."],
        ],
    },
    {
        key: "questions",
        title: "Вопросы",
        body: [
            ["Типы", "Шкала, один вариант, несколько вариантов, текст, да / нет, число."],
            ["Шкала", "Любой диапазон и шаг (1–5, 0–10, 1–3 с шагом 0,5), подписи краёв, «что лучше» (больше или меньше). Особые ответы — например, «не применимо»: они не идут в динамику и риск."],
            ["Сквозной вопрос", "Повторяется на разных этапах и даёт динамику на дашборде. Только шкала, да/нет или число. Тип у сквозного вопроса менять нельзя — иначе динамика станет несравнимой; при необходимости создайте новый вопрос."],
            ["Влияет на риск", "Ответ переводится в % от шкалы. Ниже порога «средний» — средний риск, ниже «высокий» — высокий. Падение к прошлому этапу на заданный % — средний риск, на двойной — высокий. Два «высоких» — критический."],
            ["Архив", "Ненужный вопрос можно убрать в архив — он пропадёт из выбора, но останется в старых анкетах."],
        ],
    },
    {
        key: "roles",
        title: "Участники",
        body: [
            ["Системные", "Сотрудник, Руководитель, HR — определяются карточкой адаптации."],
            ["Свои", "Например, наставник, руководитель руководителя, коллега. Заполняют анкету по ссылке без входа в платформу. Ссылку отправляет HR из карточки этапа («Ссылки для прохождения»). Автоматические напоминания им пока не уходят."],
            ["Метка", "1–2 буквы для компактной строки прогресса (С / Р / H / Н)."],
        ],
    },
    {
        key: "dashboard",
        title: "Дашборд",
        body: [
            ["Виджеты", "Сводка; сотрудники × этапы (цвет по риску или статусу, клик — открыть этап); динамика сквозного вопроса; средние по вопросам; кто не заполнил."],
            ["Настройка", "⚙ у виджета — название, ширина и параметры. ↑ ↓ — порядок, × — убрать, «+ виджет» — добавить."],
            ["Динамика", "Выберите сквозной вопрос. Группировка — по отделам, по сотрудникам или все вместе. «Замер 1, 2, 3…» — порядковый номер ответа человека. Значения в % от шкалы позволяют сравнивать разные шкалы."],
            ["Виды", "«Сохранить как…» — сохранить набор виджетов и фильтров под именем, «По умолчанию» — открывать этот вид первым. Виды общие для всех HR."],
            ["Фильтры", "Период — по плановой дате этапа; отдел."],
        ],
    },
];

export default function AdaptationHelp({ open, onClose, section = "overview" }) {
    const [active, setActive] = useState(section);
    useEffect(() => { if (open) setActive(section); }, [open, section]);
    if (!open) return null;
    const current = SECTIONS.find((s) => s.key === active) || SECTIONS[0];
    return (
        <div className="fixed inset-0 z-50 flex justify-end bg-slate-900/20" onClick={onClose} role="presentation">
            <aside
                className="flex h-full w-full max-w-xl flex-col bg-white shadow-2xl"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-label="Справка"
            >
                <div className="flex items-center justify-between border-b border-slate-200 px-4 py-2">
                    <h2 className="text-base font-bold text-slate-900">Справка: адаптация</h2>
                    <button type="button" className="px-2 text-xl leading-none text-slate-400 hover:text-slate-900" onClick={onClose} aria-label="Закрыть">×</button>
                </div>
                <div className="flex flex-wrap gap-1 border-b border-slate-100 px-3 py-2">
                    {SECTIONS.map((s) => (
                        <button
                            key={s.key}
                            type="button"
                            onClick={() => setActive(s.key)}
                            className={`rounded-md px-2 py-1 text-xs font-semibold ${active === s.key ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100"}`}
                        >
                            {s.title}
                        </button>
                    ))}
                </div>
                <dl className="flex-1 space-y-2.5 overflow-y-auto px-4 py-3 text-sm leading-5">
                    {current.body.map(([term, text]) => (
                        <div key={term}>
                            <dt className="font-semibold text-slate-900">{term}</dt>
                            <dd className="text-slate-600">{text}</dd>
                        </div>
                    ))}
                </dl>
            </aside>
        </div>
    );
}
